<template>
    <div
        ref="scrollList"
        class="scroll-smooth p-10 pt-0"
    >
        <div v-for="placement in placements" :key="placement.code" class="cz__placement">
            <placement-options :placement="placement">
            </placement-options>
        </div>
    </div>
</template>

<style lang="scss">
</style>

<script>
    import allStores from '../stores/all';

    import PlacementOptions from './PlacementOptions.vue';

    export default {
        mixins: [allStores],

        components: {
            PlacementOptions,
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            visibleGroups() {
                return this.customizerStore.visibleGroups;
            },

            useSame() {
                return this.viewController.selectedAtPlacement('GemConfiguration').placementIndependentCode === 'GEMSSAME';
            },

            placements() {
                const list = [];

                this.customizerStore.visibleGroups.forEach((g) => {
                    g.placements.forEach((p) => {
                        if (p.code === 'Family') {
                            return;
                        }

                        if (p.custom?.['baa-hidden'] === 'true') {
                            return;
                        }

                        if (/Gem\d\d/.test(p.code)) {
                            if (this.useSame && p.code !== 'Gem01') {
                                // Skip.
                            } else {
                                list.push(p);
                            }
                        } else {
                            list.push(p);
                        }
                    });
                });

                return list;
            },
        },

        methods: {
            scrollToTop() {
                this.$refs.scrollList.scrollTo(0, 0);
            },
        },
    };
</script>
